module.exports = __webpack_public_path__ + "img/bb_g1_t_ears-05.98bff91f.svg";